/**
 * Converts Strapi/GraphQL color enum value to theme path format.
 * CMS returns enums with underscore (e.g. text_baseInverse, base_bitterSweet);
 * theme expects dot notation (e.g. text.baseInverse, base.bitterSweet).
 */
export function cmsColorEnumToThemePath(
    value: string | undefined | null
): string | undefined {
    if (value == null || value === "") return undefined;
    const firstUnderscore = value.indexOf("_");
    if (firstUnderscore === -1) return value;
    return (
        value.slice(0, firstUnderscore) + "." + value.slice(firstUnderscore + 1)
    );
}
